<div *ngIf="isLoading | async" class="loader-container">
  <mat-spinner></mat-spinner>
</div>

<router-outlet />
